import { Routes, Route } from "react-router-dom";
import { Providers } from "@/lib/providers";
import { PrototypeBanner } from "@/components/PrototypeBanner";
import { Footer } from "@/components/Footer";
import { DisclaimerDialog } from "@/components/DisclaimerDialog";
import LandingPage from "@/pages/LandingPage";
import PostingPage from "@/pages/PostingPage";
import NotFound from "@/pages/NotFound";

export default function App() {
  return (
    <div className="min-h-screen flex flex-col" style={{ fontFamily: "var(--font-lexend), 'Lexend', sans-serif" }}>
      <PrototypeBanner />
      <Providers>
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/schools/postings/:postingId" element={<PostingPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </Providers>
      <Footer />
      <DisclaimerDialog />
    </div>
  );
}
